var _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _circle11, _circle12, _circle13, _circle14, _circle15, _circle16, _circle17, _circle18, _circle19, _circle20, _circle21;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgEmptystateMoon = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
    className,
    height = 82,
    titleId,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 159 82",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: className,
    height: height,
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 134.154,
    cy: 6.78865,
    r: 1.58552,
    fill: "currentColor"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 157.426,
    cy: 28.7754,
    r: 0.937778,
    fill: "currentColor"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 0.937778,
    cy: 17.3809,
    r: 0.937778,
    fill: "currentColor"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 21.678,
    cy: 53.3113,
    r: 0.937778,
    fill: "currentColor"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 129.846,
    cy: 32.9383,
    r: 0.937778,
    fill: "currentColor"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 113.846,
    cy: 80.9378,
    r: 0.937778,
    fill: "currentColor"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 33.846,
    cy: 0.937778,
    r: 0.937778,
    fill: "currentColor"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 2.23787,
    cy: 63.8682,
    r: 1.58552,
    fill: "currentColor"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 22.8484,
    cy: 28.0349,
    r: 3.80544,
    fill: "currentColor"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 130.082,
    cy: 59.1609,
    r: 2.58624,
    fill: "currentColor"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M60 19.2031H48V26.2031",
    stroke: "currentColor",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M109 39.2031V44.2031",
    stroke: "currentColor",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M97 19.2031H109V26.2031",
    stroke: "currentColor",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M60 64.2031H48V56.2031",
    stroke: "currentColor",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M97 64.2031H109V56.2031",
    stroke: "currentColor",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M94.7 45.0001C93.3101 51.8468 87.2569 57.0001 80 57.0001C71.7157 57.0001 65 50.2844 65 42.0001C65 34.2221 70.92 27.8268 78.5 27.0742",
    stroke: "currentColor",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M71.75 39C71.3358 39 71 38.6642 71 38.25C71 37.8358 71.3358 37.5 71.75 37.5C72.1642 37.5 72.5 37.8358 72.5 38.25C72.5 38.6642 72.1642 39 71.75 39Z",
    stroke: "currentColor",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M72.5 46.5151L72.5153 46.498",
    stroke: "currentColor",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M78.5 42.0151L78.5153 41.998",
    stroke: "currentColor",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M78.5001 27C77.7501 29.25 79.2499 31.5 81.6283 31.5C78.5001 36.75 81.5001 42 89.0001 41.25C89.0001 45 92.7501 45.75 94.5498 45.0204",
    stroke: "currentColor",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M48 37V41",
    stroke: "currentColor",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M48 45.0101L48.01 44.999",
    stroke: "currentColor",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 48,
    cy: 41,
    r: 8.75,
    stroke: "currentColor",
    strokeWidth: 2.5
  })));
});
export const Icon = /*#__PURE__*/React.forwardRef((_ref2, ref) => {
  let {
    className: propClassName = "",
    fill = "none",
    stroke = "currentColor",
    weight = "normal",
    height = 82,
    titleId,
    title,
    ...props
  } = _ref2;
  const className = "vector-effect-non-scaling-stroke " + propClassName;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 159 82",
    fill: fill,
    xmlns: "http://www.w3.org/2000/svg",
    className: className,
    height: height,
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 134.154,
    cy: 6.78865,
    r: 1.58552,
    fill: "currentColor"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 157.426,
    cy: 28.7754,
    r: 0.937778,
    fill: "currentColor"
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 0.937778,
    cy: 17.3809,
    r: 0.937778,
    fill: "currentColor"
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: 21.678,
    cy: 53.3113,
    r: 0.937778,
    fill: "currentColor"
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    cx: 129.846,
    cy: 32.9383,
    r: 0.937778,
    fill: "currentColor"
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    cx: 113.846,
    cy: 80.9378,
    r: 0.937778,
    fill: "currentColor"
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    cx: 33.846,
    cy: 0.937778,
    r: 0.937778,
    fill: "currentColor"
  })), _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
    cx: 2.23787,
    cy: 63.8682,
    r: 1.58552,
    fill: "currentColor"
  })), _circle20 || (_circle20 = /*#__PURE__*/React.createElement("circle", {
    cx: 22.8484,
    cy: 28.0349,
    r: 3.80544,
    fill: "currentColor"
  })), _circle21 || (_circle21 = /*#__PURE__*/React.createElement("circle", {
    cx: 130.082,
    cy: 59.1609,
    r: 2.58624,
    fill: "currentColor"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M60 19.2031H48V26.2031",
    stroke: stroke,
    strokeWidth: weight === "normal" ? 1.5 : 1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109 39.2031V44.2031",
    stroke: stroke,
    strokeWidth: weight === "normal" ? 1.5 : 1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97 19.2031H109V26.2031",
    stroke: stroke,
    strokeWidth: weight === "normal" ? 1.5 : 1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60 64.2031H48V56.2031",
    stroke: stroke,
    strokeWidth: weight === "normal" ? 1.5 : 1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97 64.2031H109V56.2031",
    stroke: stroke,
    strokeWidth: weight === "normal" ? 1.5 : 1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.7 45.0001C93.3101 51.8468 87.2569 57.0001 80 57.0001C71.7157 57.0001 65 50.2844 65 42.0001C65 34.2221 70.92 27.8268 78.5 27.0742",
    stroke: stroke,
    strokeWidth: weight === "normal" ? 1.5 : 1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.75 39C71.3358 39 71 38.6642 71 38.25C71 37.8358 71.3358 37.5 71.75 37.5C72.1642 37.5 72.5 37.8358 72.5 38.25C72.5 38.6642 72.1642 39 71.75 39Z",
    stroke: stroke,
    strokeWidth: weight === "normal" ? 1.5 : 1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.5 46.5151L72.5153 46.498",
    stroke: stroke,
    strokeWidth: weight === "normal" ? 1.5 : 1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.5 42.0151L78.5153 41.998",
    stroke: stroke,
    strokeWidth: weight === "normal" ? 1.5 : 1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.5001 27C77.7501 29.25 79.2499 31.5 81.6283 31.5C78.5001 36.75 81.5001 42 89.0001 41.25C89.0001 45 92.7501 45.75 94.5498 45.0204",
    stroke: stroke,
    strokeWidth: weight === "normal" ? 1.5 : 1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48 37V41",
    stroke: stroke,
    strokeWidth: weight === "normal" ? 1.5 : 1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48 45.0101L48.01 44.999",
    stroke: stroke,
    strokeWidth: weight === "normal" ? 1.5 : 1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 48,
    cy: 41,
    r: 8.75,
    stroke: stroke,
    strokeWidth: weight === "normal" ? 1.5 : 1
  }));
});
export default SvgEmptystateMoon;
export const raw = __webpack_public_path__ + "static/media/emptystate_moon.1a306ded18dfd4b885f0db5b7d3a5f83.svg";